/**
 * Created by or_p on 6/18/2016.
 */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import BaseElementDialog from '../BaseElementDialog/BaseElementDialog';
import * as Colors from 'material-ui/styles/colors';
import Paper from 'material-ui/Paper';
import {suffix} from 'ordinal-number-suffix';
import TextField from 'material-ui/TextField';
import SvgIcon from 'material-ui/SvgIcon';
import FontIcon from 'material-ui/FontIcon';
import IconButton from 'material-ui/IconButton';
import {HoverMixin} from 'shared/helpers/mixins';
import _ from 'lodash';
import { DragSource, DropTarget } from 'react-dnd';
import {findDOMNode} from 'react-dom';

const styles = {
  container: {
    display: 'flex',
    margin: 8,
    height: 80,
    width: 75,
  },
  index: {
    alignSelf: 'center',
    color: Colors.grey500,
    fontSize: 20,
    marginRight: 10,
    width: 75,
  },
};

export default class TabIndex extends Component {

  render() {
    const {index} = this.props;
    return (
      <span
        style={styles.container}
      >
        <span style={styles.index}>
              {index + 1}<sup>{suffix(index + 1)}</sup>&nbsp;Tab
        </span>
      </span>);
  }
}

TabIndex.propTypes = {
  index: PropTypes.number.isRequired,
};